import { PropsWithChildren } from "react"

export const SuccessBadge = ({ children }: PropsWithChildren) => {
    return (
        <div className='rounded-3xl w-fit text-xs px-3 py-1 bg-[#EAFAE5] text-[#1C8C6E]'>
            {children}
        </div>
    )
}

export const WarningBadge = ({ children }: PropsWithChildren) => {
    return (
        <div className='rounded-3xl w-fit text-xs px-3 py-1 bg-[#FBF4E4] text-[#DBAA00]'>
            {children}
        </div>
    )
}

export const ErrorBadge = ({ children }: PropsWithChildren) => {
    return (
        <div className='rounded-3xl w-fit text-xs px-3 py-1 bg-[#F2E7E7] text-[#BE3F4A]'>
            {children}
        </div>
    )
}
